import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

export default function PmiMonthlyEnergyImage({ style }) {
  return (
    <StaticQuery
      query={graphql`
        query {
          file(relativePath: { eq: "horticulture/pmi-monthly-energy.png" }) {
            childImageSharp {
              fluid(maxHeight: 450) {
                ...GatsbyImageSharpFluid
              }
              fixed(width: 1059) {
                src
              }
            }
          }
        }
      `}
      render={(data) => (
        <a href={data.file.childImageSharp.fixed.src}>
          <Img style={{ ...style }} fluid={data.file.childImageSharp.fluid} />
        </a>
      )}
    />
  );
}
